"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Sidebar.css");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SidebarToggle(_ref) {
  var Component = _ref.componentEl,
      className = _ref.className,
      margin = _ref.margin,
      padding = _ref.padding,
      status = _ref.status,
      onCollapse = _ref.onCollapse,
      onOpen = _ref.onOpen,
      position = _ref.position,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "margin", "padding", "status", "onCollapse", "onOpen", "position"]);

  var cssClasses = ['st_sidebar__toggle', "st_sidebar__toggle--" + position, "st_sidebar__toggle--" + status];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    padding: padding,
    cssClasses: cssClasses
  });

  var getIcon = function getIcon(sidebarStatus) {
    switch (sidebarStatus) {
      case 'open':
        if (position === 'left') return 'caret-left';
        return 'caret-right';

      default:
        if (position === 'left') return 'caret-right';
        return 'caret-left';
    }
  };

  var icon = getIcon(status);

  var handleClick = function handleClick(e) {
    e.preventDefault();

    if (status === 'open' || status === 'opening') {
      onCollapse();
    } else {
      onOpen();
    }
  };

  var label = status === 'open' ? 'close sidebar' : 'open sidebar';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cssClasses.join(' ')
  }, /*#__PURE__*/_react["default"].createElement("button", _extends({
    className: "st_sidebar__togglebtn",
    type: "button",
    "aria-label": label,
    onClick: handleClick
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: "mlg",
    type: icon
  })));
}

SidebarToggle.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for component, if any */
  margin: utils.spacing.marginProps,

  /** padding for component, if any. Overrides default */
  padding: utils.spacing.paddingProps,

  /** current status */
  status: _propTypes["default"].oneOf(['open', 'opening', 'collapsed', 'collapsing', 'closed', 'closing']),

  /** event handler when collapse button is clicked */
  onCollapse: _propTypes["default"].func,

  /** event handler when open button is clicked */
  onOpen: _propTypes["default"].func,

  /** position of sidebar */
  position: _propTypes["default"].oneOf(['left', 'right'])
};
SidebarToggle.defaultProps = {
  componentEl: 'button',
  className: null,
  margin: null,
  padding: {
    all: 'xs'
  },
  status: 'open',
  onCollapse: function onCollapse() {
    return null;
  },
  onOpen: function onOpen() {
    return null;
  },
  position: 'left'
};
SidebarToggle.displayName = 'Sidebar.Toggle';
var _default = SidebarToggle;
exports["default"] = _default;